import { SelectPicker } from "rsuite";
import 'rsuite/SelectPicker/styles/index.css';
import { useEffect, useState, useRef } from "react";
import {axiosInstance} from "../helpers/axiosInstance";


export function estatusColor(color) {
    switch (color){
        case "Abierto":
            return "success";
        case "En proceso":
            return 'primary';
        case "En pausa":
            return 'warning'
        case "Validando":
            return 'danger';
        case "Finalizado":
            return 'info';
        default:
            return 'secondary';
    }
}
/**
 *
 * @param setFieldValue
 * @param defaulV
 * @param edit
 * @returns {JSX.Element}
 * @constructor
 */
export default function EstatusTask({
    setFieldValue,
    values,
    edit
}) {
    const [status, setStatus] = useState([]);
    const estatusRef = useRef(null);

    useEffect(() => {
        const statusLS = JSON.parse(localStorage.getItem('estatus'));
        if (statusLS && statusLS.length > 0){
            setStatus(statusLS);
        } else {
            axiosInstance.get('todo/estatus/')
                .then((res) => {
                    setStatus(res.data.estatus);
                    localStorage.setItem('estatus', JSON.stringify(res.data.estatus));
                }).catch((err) => console.error(err));
        }
    }, []);

    function colorStatus(c){
        switch (c){
            case 1:
                return "success";
            case 2:
                return 'primary';
            case 3:
                return 'warning'
            case 4:
                return 'danger';
            case 5:
                return 'info';
            default:
                return 'secondary';
        }
    }

    const statusM = [];
    status && status.forEach(
        (item) => {
            if (item.flujo === "Tarea"){
                statusM.push({id_estatus: item.id_estatus, estatus: item.estatus, clase: colorStatus(item.id_estatus)});
            }
        }
    );

    if (statusM.length > 0) {
        return (
            <>
                <style type={'text/css'}>
                    {`
                    #id_estatus{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #id_estatus > .rs-stack{
                        display : block!important;
                    }
                    #id_estatus-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #id_estatus > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                    }
                    
                    #id_estatus-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #id_estatus-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #id_estatus-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
                </style>
                <div ref={estatusRef} className={"position-relative"}>
                    <SelectPicker
                        container={() => estatusRef.current}
                        data={statusM}
                        label={<div className={'labelSelect ps-2'}>Estatus:</div>}
                        labelKey="estatus"
                        valueKey="id_estatus"
                        searchable={false}
                        cleanable={false}
                        style={{width: "100%"}}
                        menuStyle={{width : "100%"}}
                        menuAutoWidth={false}
                        name={"id_estatus"}
                        id={"id_estatus"}
                        value={values}
                        disabled={!edit}
                        disabledItemValues={ values !== 1 ? [1] : []}
                        onChange={(value) => setFieldValue('id_estatus', value)}
                        renderMenuItem={
                            /**
                             *
                             * @param label
                             * @param item
                             * @param item.clase
                             * @returns {JSX.Element}
                             */
                                (label, item) => (
                                <div className={'bg-body '}>
                            <span className={"fs-7 fw-bold badge badge-light-" + item.clase}>
                                <i className="bi bi-caret-right mx-2" style={{color: "#0076bc"}}></i>
                                {label}
                            </span>
                                </div>
                            )}
                        renderValue={
                            /**
                             *
                             * @param value
                             * @param item
                             * @param item.clase
                             * @param item.estatus
                             * @returns {JSX.Element}
                             */
                                (value, item) => {
                                return (
                                    <div className={"fs-7 fw-bold text-" + item.clase}>
                                        {item.estatus}
                                    </div>
                                );
                            }}
                    />
                </div>
            </>
        );
    }
}
